/**
 * Supabase Client Configuration
 * 
 * This file initializes the Supabase client for authentication.
 * 
 * Setup:
 * 1. Create a Supabase project at https://supabase.com
 * 2. Go to Project Settings > API
 * 3. Copy your Project URL and anon/public key
 * 4. Add to your Vercel environment variables:
 *    - REACT_APP_SUPABASE_URL
 *    - REACT_APP_SUPABASE_ANON_KEY
 */

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn(
    "⚠️ Supabase credentials not found. Auth will be disabled.\n" +
    "Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your environment."
  );
}

// Create client only if credentials exist
export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

// Helper to check if Supabase is configured
export const isSupabaseConfigured = () => !!supabase;

export default supabase;
